import { atom } from "jotai";

/**
 * Set from outside React when the server refuses this bundle a second time —
 * reloading has not helped, so the app stops and asks the user to refresh.
 */
export const isClientOutdatedAtom = atom<boolean>(false);
